<template>
  <validation-observer
    ref="creditClassTeacherSaveFormRef"
    #default="{invalid}"
  >
    <b-modal
      id="creditClassTeacherBulkSaveModal"
      centered
      body-class="position-static"
      title="Thêm giảng viên cho lớp tín chỉ"
      :no-close-on-backdrop="true"
      @show="onShow"
      @hide="onHide"
    >
      <b-form>
        <b-form-group label-for="departmentId">
          <template v-slot:label>
            Khoa/Bộ môn <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Khoa/Bộ môn"
            rules="required"
          >
            <v-select
              v-model="departmentId"
              :options="departments"
              :reduce="option => option.value"
              @input="onDepartmentChange"
            />
            <b-form-invalid-feedback :state="getElementState(errors)">
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-form-group>
        <b-form-group label-for="teacherId">
          <template v-slot:label>
            Giảng viên <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Giảng viên"
            rules="required"
          >
            <v-select
              v-model="targetData.teacherId"
              :options="teachers"
              :reduce="option => option.value"
            />
            <b-form-invalid-feedback :state="getElementState(errors)">
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-form-group>
        <b-form-group
          label="Số tiết dạy"
          label-for="lessonNum"
        >
          <b-form-input
            id="lessonNum"
            v-model="targetData.lessonNum"
            name="maxQty"
          />
        </b-form-group>
        <b-form-group label-for="status">
          <template v-slot:label>
            Trạng thái <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Trạng thái"
            rules="required"
          >
            <v-select
              v-model="targetData.status"
              :options="statusOptions"
              :reduce="option => option.value"
            />
            <b-form-invalid-feedback :state="getElementState(errors)">
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-form-group>
        <b-form-group label-for="orderNo">
          <template v-slot:label>
            Thứ tự <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Thứ tự"
            rules="required"
          >
            <b-form-input
              id="orderNo"
              v-model="targetData.orderNo"
              name="orderNo"
              placeholder="Nhập thứ tự"
              :state="getElementState(errors)"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group label-for="syncLms">
          <template v-if="targetData.syncLms == '1'">
            Đồng bộ giảng viên LMS
          </template>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave('hide')"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu lại
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide('creditClassTeacherBulkSaveModal')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
      <b-overlay
        no-wrap
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="isLoading"
      />
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BForm, BFormGroup, BFormInput, BModal, BOverlay, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import { mapActions, mapGetters } from 'vuex'
import Ripple from 'vue-ripple-directive'
import * as events from 'events'
import { getUser } from '@/auth/utils'
import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'
import { showErrorToast, showSuccessToast } from '@/utils/notification'

export default {
  name: 'CreditClassTeacherSave',
  components: {
    BFormGroup,
    BFormInput,
    BModal,
    BForm,
    BOverlay,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    creditClassIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
      departmentId: null,
      targetData: {
        creditClassIds: this.creditClassIds,
        teacherId: null,
        lessonNum: null,
        status: 1,
        orderNo: null,
        syncLms: 0,
      },
      required,
    }
  },
  watch: {
    creditClassIds(newVal) {
      this.targetData.creditClassIds = newVal
    },
  },
  // eslint-disable-next-line vue/order-in-components
  computed: {
    events() {
      return events
    },
    ...mapGetters({
      statuses: 'creditClassTeacher/statuses',
      resourceName: 'creditClassTeacher/resourceName',
      departments: 'dropdown/departments',
      teachers: 'dropdown/teachers',
    }),
    statusOptions() {
      return this.statuses
    },
  },
  methods: {
    ...mapActions({
      getDepartments: 'dropdown/getDepartments',
      getTeachers: 'dropdown/getTeachers',
    }),
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    async onDepartmentChange(departmentId) {
      this.targetData.teacherId = null
      await this.getTeachers({ departmentId })
    },
    async onShow() {
      this.isLoading = true
      const cUser = getUser()
      const userOrgId = (cUser.orgId ? cUser.orgId : 0)
      await this.getDepartments({ organizationId: userOrgId })
      this.departmentId = this.departments[0].value
      await this.getTeachers({ departmentId: this.departmentId })
      this.isLoading = false
    },
    onHide() {
      this.$refs
        .creditClassTeacherSaveFormRef
        .reset()
      this.targetData = {
        creditClassIds: [],
        teacherId: null,
        lessonNum: null,
        status: 1,
        orderNo: null,
      }
    },
    async createBulkData(params) {
      try {
        const response = await axios.post('uni/credit_class/teachers/bulk-create', params)
        const { data } = response
        return {
          isSuccessful: data.code === ApiCode.SUCCESS,
          message: data.message,
        }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async onSave(type = null) {
      const valid = this.$refs
        .creditClassTeacherSaveFormRef
        .validate()
      if (valid) {
        this.isLoading = true
        try {
          const response = await this.createBulkData(this.targetData)
          if (response) {
            const {
              isSuccessful,
              message,
            } = response
            if (isSuccessful) {
              showSuccessToast(this, message)
              if (type === 'hide') {
                this.$bvModal.hide('creditClassTeacherBulkSaveModal')
              }
              this.$emit('succeed')
            } else {
              showErrorToast(this, message)
            }
          }
        } catch (e) {
          showErrorToast(this, e)
        } finally {
          this.isLoading = false
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
